import React, { useEffect, useState } from "react";
import { jsPDF } from "jspdf";
import "./BillingInfo.css";
import "./case-paper.css";
import axios from "axios";
import dayjs from "dayjs";

// Import your images (make sure to add them to your project)
import headerImage from "../../../Images/header-logo.png";
import footerImage from "../../../Images/footer-logo.png";
import InvoiceModal from "./InvoiceModal";
import SkeletonLoader from "../../resuableComponents/SkeletonLoader";
import ViewInvoiceModal from "./ViewInvoiceModal";
import { FaEdit, FaEye, FaPlus, FaFileAlt } from "react-icons/fa";
import MedicalCertificateModal from "./MedicalCertificateModal";
import { toast } from "react-toastify";
// import logoImage from './assets/ayurveda-logo.png';

const BillingInfo = ({ patientId }) => {
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);

  const [isViewInvoiceModalOpen, setIsViewInvoiceModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [selectedBillType, setSelectedBillType] = useState(null);

  const openInvoiceModal = (consultation, billType) => {
    setSelectedBillType(billType);
    setSelectedConsultation(consultation);
    setIsInvoiceModalOpen(true);
  };

  const closeInvoiceModal = () => {
    setIsInvoiceModalOpen(false);
    setSelectedConsultation(null);
    setSelectedBillType(null);
  };

  const openViewInvoiceModal = (appointmentId, billType) => {
    setSelectedBillType(billType);
    setSelectedAppointmentId(appointmentId);
    setIsViewInvoiceModalOpen(true);
  };

  const closeViewInvoiceModal = () => {
    setIsViewInvoiceModalOpen(false);
    setSelectedAppointmentId(null);
    setSelectedBillType(null);
  };

  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [patient, setPatient] = useState(null);
  const [loadingPatient, setLoadingPatient] = useState(false);
  const [isCertModalOpen, setIsCertModalOpen] = useState(false);

  const authData = JSON.parse(localStorage.getItem("authData"));

  const formatDate1 = (dateStr) => {
    if (!dateStr) return "N/A";

    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");

    const isoString = `${year}-${month}-${day}T${timePart}`;
    return dayjs(isoString).format("DD/MM/YYYY");
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return dayjs(dateString).format("DD/MM/YYYY");
  };

  const normalizeTreatment = (t) => {
    if (typeof t === "string") return { name: t, cost: 0 };
    return { name: t.name, cost: t.cost ?? 0 };
  };

  const aggregateVisitField = (consultation, visits, field) => {
    if (visits?.length > 0) {
      return visits.flatMap((v) => v[field] || []);
    }
    return consultation?.[field] || [];
  };

  useEffect(() => {
    fetchConsultations();
    fetchPatient();
  }, [patientId]);

  const fetchPatient = async () => {
    if (!patientId) {
      console.warn("No patient ID found");
      return;
    }

    if (!authData?.accessToken) {
      console.error("Authentication required");
      return;
    }

    try {
      setLoadingPatient(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}get-patient?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${authData.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      setPatient(response.data.result);
    } catch (err) {
      console.error("Failed to fetch patient:", err);
    } finally {
      setLoadingPatient(false);
    }
  };

  const fetchConsultations = async () => {
    if (!patientId) {
      console.warn("No patient ID found");
      return;
    }

    if (!authData?.accessToken) {
      console.error("Authentication required");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}patient-history?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${authData.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const consultations = response.data.history
        .filter((item) => item.consultation)
        .map((item) => {
          const visits = item.visits || item.consultation.visits || [];
          const treatments = aggregateVisitField(
            item.consultation,
            visits,
            "treatments"
          ).map(normalizeTreatment);
          const prescribedMedicines = aggregateVisitField(
            item.consultation,
            visits,
            "prescribedMedicines"
          );

          return {
            ...item.consultation,
            visits,
            treatments,
            prescribedMedicines,
            appointmentDate: item.appointmentDate,
            doctorName: item.doctor?.name || "N/A",
          };
        });

      setConsultations(consultations);
    } catch (err) {
      console.error("Failed to fetch consultations:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateCertificate = () => {
    if (!patient) {
      toast.error("Patient information not available");
      return;
    }

    if (consultations.length === 0) {
      toast.error("No medical records found for this patient. Cannot generate medical certificate.");
      return;
    }

    setIsCertModalOpen(true);
  };


  //
  //   const doc = new jsPDF();
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();

  //   // Add header image
  //   doc.addImage(headerImage, 'JPEG', 0, 0, pageWidth, 30);

  //   // Client and invoice info section
  //   doc.setFontSize(10);
  //   doc.setTextColor(100, 100, 100);
  //   doc.text('Invoice #: AYUR2023-001', 20, 45);
  //   doc.text('Date: ' + new Date().toLocaleDateString(), 20, 50);
  //   doc.text('Client: Ayurveda Seeker', pageWidth - 20, 45, { align: 'right' });
  //   doc.text('Therapist: Dr. Vaidya Sharma', pageWidth - 20, 50, { align: 'right' });

  //   // Decorative line with Ayurveda style
  //   doc.setDrawColor(139, 69, 19); // Brown color
  //   doc.setLineWidth(0.8);
  //   doc.line(20, 55, pageWidth - 20, 55);

  //   // Consultation section
  //   doc.setFontSize(12);
  //   doc.setTextColor(72, 120, 84); // Ayurvedic green
  //   doc.text('Consultation Charges:', 20, 65);
  //   doc.setFontSize(12);
  //   doc.setTextColor(40, 40, 40);
  //   doc.text('Ayurvedic Doctor Consultation', 30, 75);
  //   doc.text(`₹${doctorFees}`, pageWidth - 20, 75, { align: 'right' });

  //   // Treatments section with decorative background
  //   doc.setFillColor(245, 245, 220); // Light beige
  //   doc.rect(15, 85, pageWidth - 30, 20, 'F');
  //   doc.setFontSize(12);
  //   doc.setTextColor(72, 120, 84);
  //   doc.text('Ayurvedic Treatments:', 20, 95);

  //   treatments.forEach((treatment, index) => {
  //     const yPos = 105 + index * 10;
  //     doc.setFontSize(10);
  //     doc.setTextColor(40, 40, 40);
  //     doc.text('• ' + treatment.name, 30, yPos);
  //     doc.text(`₹${treatment.cost}`, pageWidth - 20, yPos, { align: 'right' });
  //   });

  //   // Medicines section
  //   const treatmentsEndY = 105 + treatments.length * 10;
  //   doc.setFillColor(245, 245, 220);
  //   doc.rect(15, treatmentsEndY + 5, pageWidth - 30, 20, 'F');
  //   doc.setFontSize(12);
  //   doc.setTextColor(72, 120, 84);
  //   doc.text('Herbal Medicines:', 20, treatmentsEndY + 15);

  //   medicines.forEach((medicine, index) => {
  //     const yPos = treatmentsEndY + 25 + index * 10;
  //     doc.setFontSize(10);
  //     doc.setTextColor(40, 40, 40);
  //     doc.text('• ' + medicine.name, 30, yPos);
  //     doc.text(`₹${medicine.cost}`, pageWidth - 20, yPos, { align: 'right' });
  //   });

  //   // Total calculation
  //   const medicinesEndY = treatmentsEndY + 25 + medicines.length * 10;
  //   const total = doctorFees +
  //                treatments.reduce((acc, curr) => acc + curr.cost, 0) +
  //                medicines.reduce((acc, curr) => acc + curr.cost, 0);

  //   // Total section with decorative border
  //   doc.setDrawColor(139, 69, 19);
  //   doc.setLineWidth(0.5);
  //   doc.roundedRect(15, medicinesEndY + 10, pageWidth - 30, 20, 3, 3, 'S');
  //   doc.setFontSize(14);
  //   doc.setFont('helvetica', 'bold');
  //   doc.setTextColor(72, 120, 84);
  //   doc.text('Total Amount:', 30, medicinesEndY + 23);
  //   doc.text(`₹${total}`, pageWidth - 20, medicinesEndY + 23, { align: 'right' });

  //   // Ayurveda note
  //   doc.setFontSize(10);
  //   doc.setTextColor(100, 100, 100);
  //   doc.text('* Includes all taxes. Medicines are prepared fresh daily using traditional methods.',
  //     pageWidth / 2, medicinesEndY + 35, { align: 'center' });

  //   // Footer image
  //   doc.addImage(footerImage, 'PNG', 0, pageHeight - 30, pageWidth, 30);

  //   // Save the PDF
  //   doc.save('ashtang-ayurveda-invoice.pdf');
  // };

  return (
    <div className="billing-info-container">
      <div className="billing-info-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 className="billing-info-title">Billing Info</h2>
        <button
          className="ba-button ba-button-primary"
          onClick={handleGenerateCertificate}
          disabled={!patient || loadingPatient || loading}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <FaFileAlt /> Generate Medical Certificate
        </button>
      </div>

      {loading ? (
        <SkeletonLoader variant="table" count={5} />
      ) : consultations.length > 0 ? (
        <div className="billing-info-table-wrapper">
          <table className="billing-info-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Doctor</th>
                <th>Treatments</th>
                <th>Medicines</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {consultations.map((c, idx) => (
                <tr key={idx}>
                  <td>{formatDate1(c.appointmentDate)}</td>
                  <td>{c.doctorName}</td>

                  <td>
                    <ul>
                      {c.treatments?.filter(Boolean).length > 0 ? (
                        c.treatments.filter(Boolean).map((t, i) => (
                          <li key={i}>
                            {typeof t === "string" ? t : t.name || "Treatment"} - ₹{typeof t === "string" ? 0 : t.cost || 0}
                          </li>
                        ))
                      ) : (
                        <li>N/A</li>
                      )}
                    </ul>
                  </td>
                  <td>
                    <ul>
                      {c.prescribedMedicines?.filter(Boolean).length > 0 ? (
                        c.prescribedMedicines.filter(Boolean).map((m, i) => (
                          <li key={i}>
                            {m.name || "Medicine"} - {m.dosage || m.quantity || ""}
                          </li>
                        ))
                      ) : (
                        <li>N/A</li>
                      )}
                    </ul>
                  </td>
                  <td>
                    {(() => {
                      const treatmentInvoice = c.invoiceId || null;
                      const medicineInvoice = c.medicineInvoiceId || null;
                      const treatmentType = treatmentInvoice && typeof treatmentInvoice === "object"
                        ? treatmentInvoice.invoiceType
                        : null;
                      const legacyInvoice = treatmentInvoice && !treatmentType && !medicineInvoice;
                      const appointmentId = c.appointment?._id || c.appointment;

                      if (legacyInvoice) {
                        return (
                          <button
                            className="ba-button ba-button-view "
                            onClick={() => openViewInvoiceModal(appointmentId)}
                          >
                            <FaEye className="billing-info-button-icon mr-1" />
                            View Invoice
                          </button>
                        );
                      }

                      return (
                        <div className="billing-invoice-actions">
                          {treatmentType === "treatment" ? (
                            <button
                              className="ba-button ba-button-view "
                              onClick={() => openViewInvoiceModal(appointmentId, "treatment")}
                            >
                              <FaEye className="billing-info-button-icon mr-1" />
                              View Treatment Invoice
                            </button>
                          ) : (
                            <button
                              className="ba-button ba-button-secondary"
                              onClick={() => openInvoiceModal(c, "treatment")}
                            >
                              <FaPlus className="billing-info-button-icon" />
                              Create Treatment Invoice
                            </button>
                          )}
                          {medicineInvoice ? (
                            <button
                              className="ba-button ba-button-view "
                              onClick={() => openViewInvoiceModal(appointmentId, "medicine")}
                            >
                              <FaEye className="billing-info-button-icon mr-1" />
                              View Medicine Invoice
                            </button>
                          ) : (
                            <button
                              className="ba-button ba-button-secondary"
                              onClick={() => openInvoiceModal(c, "medicine")}
                            >
                              <FaPlus className="billing-info-button-icon" />
                              Create Medicine Invoice
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="billing-info-empty-state">
          
          <h3 className="billing-info-empty-title">No consultations yet</h3>
          <p className="billing-info-empty-description">
            Consultations will appear here after being added to appointments.
          </p>
        </div>
      )}
      {isInvoiceModalOpen && selectedConsultation && (
        <InvoiceModal
          consultation={selectedConsultation}
          onClose={closeInvoiceModal}
          patientId={patientId}
          billType={selectedBillType || "treatment"}
          refreshConsultations={fetchConsultations}
        />
      )}
      {isViewInvoiceModalOpen && selectedAppointmentId && (
        <ViewInvoiceModal
          appointmentId={selectedAppointmentId}
          billType={selectedBillType}
          onClose={closeViewInvoiceModal}
        />
      )}

      {isCertModalOpen && patient && (
        <MedicalCertificateModal
          open={isCertModalOpen}
          onClose={() => setIsCertModalOpen(false)}
          patient={patient}
        />
      )}
    </div>
  );
};

export default BillingInfo;
